import commonDataReducer, {
  COMMON_DATA_REDUCER_KEY,
  loadCommonData,
} from './commonDataReducer';

export { COMMON_DATA_REDUCER_KEY, loadCommonData };

export default commonDataReducer;
